import es from './es/messages';
import en from './en/messages';
import ay from './ay/messages';

export default {
  es,
  en,
  ay
};



// WEBPACK FOOTER //
// ./src/common/lang/index.js